<template>
  <div class="mt-1">
    <b-list-group-item
      :variant="isSelected ? 'primary' : null"
      class="parent-card curved-border"
      @click="handleParentClick"
    >
      <div class="d-flex align-items-center">
        <b-avatar
          :text="getInitials(parent.first_name, parent.last_name)"
          size="40"
          variant="warning"
          class="mr-3"
        />
        
        <div class="flex-grow-1">
          <div class="font-weight-bold">{{ parent.full_name }}</div>
          <small class="text-gray">
            {{ parent.phone }}
            <span v-if="parent.children_count"> • {{ parent.children_count }} {{ parent.children_count === 1 ? 'child' : 'children' }}</span>
          </small>
        </div>
        
        <div class="d-flex align-items-center">
          <feather-icon
            v-if="isSelected"
            icon="CheckIcon"
            size="16"
            class="text-primary mr-2"
          />
          <feather-icon
            :icon="showChildren ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            size="16"
            class="text-gray"
          />
        </div>
      </div>
    </b-list-group-item>
    
    <!-- Children List - Only shown when showChildren is true -->
    <div v-if="showChildren && parent.children && parent.children.length > 0"
         class="children-list">
      <b-list-group flush>
        <div
          v-for="child in parent.children"
          :key="child.id"
          class="child-item pl-5 mt-1"
          style="cursor: pointer;"
          @click="toggleChild(child.id)"
        >
          <div class="d-flex align-items-center curved-border">
            <b-avatar
              v-if="child.photo"
              :src="`${$store.getters['auth/storageUrl']}/${child.photo}`"
              size="30"
              class="mr-3"
            />
            <b-avatar
              v-else
              :text="getInitials(child.first_name, child.last_name)"
              size="30"
              variant="light-primary"
              class="mr-3"
            />
            
            <div class="flex-grow-1">
              <div class="font-weight-bold">{{ child.full_name }}</div>
              <small class="text-muted">
                {{ child.student_id }}
                <span v-if="child.class_name"> • {{ child.class_name }}</span>
              </small>
            </div>
            
            <!-- Toggle Icon -->
            <div class="toggle-icon">
              <feather-icon
                v-if="isChildSelected(child.id)"
                icon="CheckCircleIcon"
                size="18"
                class="text-success cursor-pointer"
              />
              <feather-icon
                v-else
                icon="XIcon"
                size="18"
                class="text-danger cursor-pointer"
              />
            </div>
          </div>
        </div>
      </b-list-group>
    </div>
  </div>
</template>

<script>
import {
  BListGroup, BListGroupItem, BAvatar,
} from 'bootstrap-vue'

export default {
  name: 'ParentCard',
  components: {
    BListGroup,
    BListGroupItem,
    BAvatar,
  },
  props: {
    parent: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showChildren: false,
      selectedChildren: [] // Array of selected child objects with {id, class_id}
    }
  },
  watch: {
    isSelected: {
      handler(newVal) {
        if (newVal && this.parent.children) {
          // Initialize with all children selected when parent is selected
          this.selectedChildren = this.parent.children.map(child => ({ id: child.id, class_id: child.class_id }))
          this.emitChildrenChanged()
        }else{
          this.showChildren = false
        }
      },
      immediate: true
    }
  },
  methods: {
    getInitials(firstName, lastName) {
      const first = firstName ? firstName.charAt(0).toUpperCase() : ''
      const last = lastName ? lastName.charAt(0).toUpperCase() : ''
      return first + last
    },
    handleParentClick() {
      this.showChildren = !this.showChildren
      this.$emit('select', this.parent)
    },
    toggleChild(childId) {
      const childIndex = this.selectedChildren.findIndex(child => child.id === childId)
      if (childIndex !== -1) {
        this.selectedChildren.splice(childIndex, 1)
      } else {
        // Find the child object to get the class_id
        const childObj = this.parent.children.find(child => child.id === childId)
        this.selectedChildren.push({ id: childId, class_id: childObj.class_id })
      }
      this.emitChildrenChanged()
    },
    isChildSelected(childId) {
      return this.selectedChildren.some(child => child.id === childId)
    },
    emitChildrenChanged() {
      this.$emit('children-changed', this.selectedChildren)
    }
  }
}
</script>

<style scoped>
.parent-card {
  cursor: pointer;
  transition: all 0.2s ease;
}

.parent-card:hover {
  background-color: var(--bs-gray-100);
}

.children-list {
  border-left: 2px solid var(--bs-primary);
  margin-left: 1rem;
}

.child-item {
  background-color: var(--bs-gray-50);
  border-left: none;
  border-right: none;
  border-bottom: 1px solid var(--bs-gray-200);
}

.child-item:last-child {
  border-bottom: none;
}

.cursor-pointer {
  cursor: pointer;
}

.toggle-icon {
  cursor: pointer;
  padding: 0.25rem;
  border-radius: 50%;
  transition: background-color 0.2s ease;
}

.toggle-icon:hover {
  background-color: var(--bs-gray-200);
}

.curved-border {
  border: 1px solid #fa2;
  padding: 10px;
  border-radius: 10px;
}

</style> 